import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import "./breadcrumb.css";
const Breadcrumb = ({
  bread2,
  br2_link,
  bread3,
  br3_link,
  bread4,
  br4_link,
  bread5,
  br5_link,
  bread6,
  br6_link,
}) => {
  return (
    <Fragment>
      <div className="bread_body">
        <div className="bread_item">
          <Link className="bread_links" to="/">
            صفحه اصلی
          </Link>
        </div>

        <i className="bread_logo  uil uil-arrow-left"></i>
        {bread2 ? (
          <div className="bread_item">
            <Link className="bread_links" to={br2_link}>
              {bread2}
            </Link>
            {bread3 ? <i className="bread_logo uil uil-arrow-left"></i> : null}
          </div>
        ) : null}
        {bread3 ? (
          <div className="bread_item">
            <Link className="bread_links" to={br3_link}>
              {bread3}
            </Link>
            {bread4 ? <i className="bread_logo uil uil-arrow-left"></i> : null}
          </div>
        ) : null}
        {bread4 ? (
          <div className="bread_item">
            <Link className="bread_links" to={br4_link}>
              {bread4}
            </Link>
            {bread5 ? <i className="bread_logo uil uil-arrow-left"></i> : null}
          </div>
        ) : null}
        {bread5 ? (
          <div className="bread_item">
            <Link className="bread_links" to={br5_link}>
              {bread5}
            </Link>
            {bread6 ? <i className="bread_logo uil uil-arrow-left"></i> : null}
          </div>
        ) : null}
        {bread6 ? (
          <div className="bread_item">
            <Link className="bread_links" to={br6_link}>
              {bread6}
            </Link>
          </div>
        ) : null}
      </div>
    </Fragment>
  );
};

export default Breadcrumb;
